import React from "react";
import ContactForm from "../components/ContactForm";
import Layout from "../components/Layout";
import Helmet from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";
// import ContactMeta from "../components/meta/ContactMeta";

const Contact = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      draftboxSettings {
        identity {
          siteName
        }
      }
    }
  `);

  return (
    <>
      <Helmet>
        <title>Contact | {data.draftboxSettings.identity.siteName}</title>
      </Helmet>
      <Layout>
        <ContactForm />
      </Layout>
    </>
  );
};

export default Contact;
